<!--
 * @Author: RYL
 * @Description: 设备添加时只允许添加只能从属于云监测项目中的设备
 * @Date: 2020-10-12 13:53:11
 * @LastEditTime: 2022-04-01 18:01:58
-->
<template>
  <div>
    <el-table :height="400" size="mini" id="out-table" :data="deviceList" :header-cell-style="{ background: '#e4f1ff' }"
      :row-class-name="tableRowClassName" row-key="deviceId" @selection-change="handleSelectionChange"
      @sort-change="sortChange">
      <el-table-column align="center" v-if="isChexkBox !== false" type="selection" width="50" reserve-selection
        :selectable="checkboxInit"></el-table-column>
      <el-table-column align="center" v-else-if="isChexkBox === false && isRadio === true" width="50">
        <template slot-scope="scope">
          <el-radio v-if="scope.$index === 0" disabled>{{ '' }}</el-radio>
          <el-radio v-else v-model="radioValue"
            :disabled="(compareVersionV(scope.row.deviceSoftwareVer, 'v2.3') == -1) ? true : false"
            :label="scope.row.deviceId" @change="handleSelectionChange(scope.row)">{{ '' }}</el-radio>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.devicelist.SerialNumber')" width="60" align="center">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" style="color:#409eff;font-size:15px;">{{ scope.$index }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.FastAccess.deviceSn')" sortable="custom" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" class="table-font">{{ scope.row.deviceSn }}</span>
          <el-input size="mini" v-model="seek.deviceSn" v-else clearable></el-input>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.terminalList.name')" min-width="120px" sortable="custom">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" class="table-font">{{ scope.row.deviceName }}</span>
          <el-input size="mini" v-model="seek.deviceName" v-else clearable></el-input>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('lang.devicelist.Equipment')" sortable="custom" min-width="150px">
      <template slot-scope="scope">
        <span v-if="scope.$index !== 0" class="table-font">{{scope.row.groupName}}</span>
        <el-input size="mini" v-model="seek.deviceGname" v-else clearable></el-input>
      </template>
      </el-table-column>-->
      <el-table-column :label="$t('lang.devicelist.statevoid')" width="120px" align="center">
        <template slot-scope="scope">
          <div v-if="scope.$index !== 0">
            <el-tag v-if="scope.row.deviceIsconnected == 3" type="success">{{ $t("lang.devicelist.connected")
            }}</el-tag>
            <el-tag v-else type="danger">{{ $t("lang.devicelist.not") }}</el-tag>
          </div>
          <!-- <el-select v-else v-model="seek.deviceIsconnected" size="mini">
            <el-option label="已连接" value="3"></el-option>
            <el-option label="未连接" value="4"></el-option>
          </el-select> -->
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.devicelist.IP')" width="120px">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" class="table-font">{{ scope.row.deviceIp }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.devicelist.Version')" width="120px">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" class="table-font">{{ scope.row.deviceSoftwareVer }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Monitor.deviceAddress')" min-width="200px">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" class="table-font">{{ scope.row.deviceAddress }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="total" :offset="offset" :limit="limit" @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges">
    </pagination>
  </div>
</template>
<script>
import { PublicComponent } from "@/mixins/common"
import pagination from "@/components/pagination"
import TableComponent from '@/components/TableComponent/index'
import { Columns } from './tableConfig'
import { queryKeyword } from "@/api/devicelist"
import { getDeviceList } from "@/api/cloudMonitor/deviceList"
import { compareVersion } from "@/utils/Date";
export default {
  props: ['isChexkBox', 'isRadio'],
  mixins: [PublicComponent],
  components: {
    TableComponent,
    pagination,
  },
  data() {
    return {
      Columns,
      selectDevices: [],
      deviceList: [],
      radioValue: '',
      //表格排序
      sort: {
        sn: null, //序列号
        devicename: null, //设备名称
        isconnected: null, //连接状态
        olinetime: null, //在线时长
        version: null, //软件版本
      },
      seek: {
        deviceSn: "", //序列号
        deviceGname: "", //组名
        deviceName: "", //设备名
        deviceIp: "", //ip地址
        deviceIsconnected: "", //状态‘3’表示连接，其他断开'
        deviceTraffic: "", //流量
        signalStrength: "", //信号强度
        nettype: "", //网络制式0   NONE 1 GSM 2 GPRS 3 CDMA&EVDO 4 CDMA 5 EVDO 6 WCDMA 7 HSDPA 8 HSUPA 9 HSPA+ 10 TD-SCDMA 11 FDD-LTE 12 TD-LTE 13 AUTO
        deviceOnlinetime: "", //在线时长
        deviceUpdate: "", //最后活跃
        deviceSoftwareVer: "", //软件版本
        deviceAddress: "", //设备位置
        sortNum: ''
      },
    }
  },
  mounted() {
    this.queryKeyword()
  },
  methods: {
    compareVersionV(v1, v2) {
      return compareVersion(v1, v2)
    },
    // 分页获取设备列表
    queryKeyword() {
      // queryKeyword(
      //   this.offset,
      //   this.limit,
      //   [
      //     this.seek.deviceSn,
      //     this.seek.deviceGname,
      //     this.seek.deviceName,
      //     this.seek.deviceIp,
      //     this.seek.deviceIsconnected,
      //     this.seek.deviceTraffic,
      //     this.seek.signalStrength,
      //     this.seek.nettype,
      //     this.seek.deviceOnlinetime,
      //     this.seek.deviceUpdate,
      //     this.seek.deviceSoftwareVer,
      //     this.seek.deviceAddress
      //   ],
      //   this.sort,
      //   this.groupId
      // ).then(res => {
      //   if(res.data.code === 0) {
      //     let data = res.data.data
      //     this.deviceList = data.list
      //     this.total = data.total
      //     this.deviceList.unshift({})
      //   }
      // });
      getDeviceList({
        "current": this.offset, "size": this.limit, type: 2, deviceSn: this.seek.deviceSn ? this.seek.deviceSn : undefined,
        deviceName: this.seek.deviceName ? this.seek.deviceName : undefined, deviceIsconnected: this.seek.deviceIsconnected ? this.seek.deviceIsconnected : undefined, sortNum: this.seek.sortNum ? this.seek.sortNum : undefined,
      }).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data
          this.deviceList = data.records
          this.total = data.total
          this.deviceList.unshift({})
        }
      })
    },
    //表格排序
    // sortChange({ column, prop, order }) {
    //   //每次点击清空一次排序的赋值
    //   this.sort = {
    //     sn: null, //序列号
    //     devicename: null, //设备名称
    //     isconnected: null, //连接状
    //     olinetime: null, //在线时长
    //     version: null, //软件版本
    //   };
    //   // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
    //   let label = null;
    //   if (column != null) {
    //     label = column.label;
    //   } else {
    //     label = null;
    //   }
    //   let sortlist = null;
    //   if (column != null) {
    //     if (column.order == "ascending") {
    //       sortlist = 0;
    //     } else if (column.order == "descending") {
    //       sortlist = 1;
    //     } else {
    //       sortlist = null;
    //     }
    //   }
    //   if (label == "序列号") {
    //     this.sort.sn = sortlist;
    //   } else if (label == this.$t("lang.devicelist.Equipment")) {
    //     this.sort.groupname = sortlist;
    //   } else if (label == this.$t("lang.devicelist.DeviceName")) {
    //     this.sort.devicename = sortlist;
    //   }else if (label == this.$t("lang.devicelist.statevoid")) {
    //     this.sort.isconnected = sortlist;
    //   }else if (label == this.$t("lang.devicelist.Version")) {
    //     this.sort.version = sortlist;
    //   }
    // },
    sortChange(e) {
      let prop = e.column.label
      if (prop == '序列号') {
        if (e.column.order == 'descending') {
          this.seek.sortNum = 2
        } else {
          this.seek.sortNum = 1
        }
      } else if (prop == '名称') {
        if (e.column.order == 'descending') {
          this.seek.sortNum = 4
        } else {
          this.seek.sortNum = 3
        }
      } else if (prop == 'deviceIp') {
        if (e.column.order == 'descending') {
          this.seek.sortNum = 6
        } else {
          this.seek.sortNum = 5
        }
      } else if (prop == 'deviceAddress') {
        if (e.column.order == 'descending') {
          this.seek.sortNum = 8
        } else {
          this.seek.sortNum = 7
        }
      } else {
        this.seek.sortNum = ''
      }
    },
    //表格状态
    GetStatus(status) {
      return {
        status: status == 3 ? 'success' : 'danger',
        TagName: status == 3 ? this.$t("lang.devicelist.connected") : this.$t("lang.devicelist.not")
      }
    },
    // 选中设备
    handleSelectionChange(val) {
      if (this.isRadio) { // 若只是单选，返回数据只是一个对象，把对象push进数组中
        this.selectDevices = []
        this.selectDevices.push(val)
      } else { // 若是多选，则直接返回的是数组
        this.selectDevices = val
      }

    },
    // 获取选中设备(其他组件引用时需要使用)
    getSelectDevices() {
      return this.selectDevices
    },
    // 取消选中状态
    cancelSelect() {
      console.log(this.$refs.multypleTable.cancelSelect());
      this.$refs.multypleTable.cancelSelect()
    },
    // 动态设置表格行样式
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex > 0) {
        if (compareVersion(row.deviceSoftwareVer, 'v2.3') == -1) {
          return 'table-warning'
        }

      }
      return ''
    },
    // 设置复选框是否可选
    checkboxInit(row, index) {
      if (index <= 0) {
        return 0
      } else {
        if (compareVersion(row.deviceSoftwareVer, 'v2.3') == -1) {
          return 0
        } else {
          return 1
        }
      }
    }
  }
}
</script>
<style scoped>
.devices {
  width: 70%;
}

.projectGroup {
  width: 30%;
  overflow: scroll;
}

.devices-title {
  font-size: 16px;
  margin-bottom: 10px;
}

.load-more {
  margin-top: 50px;
  text-align: center;
}

.table-font {
  font-size: 0.25rem;
}

.el-table .table-warning {
  background: oldlace;
}

.tips {
  width: 20px;
  height: 20px;
  background-color: #f8efef;
  margin-right: 10px;
}
</style>
<style>
.el-table .table-warning {
  /* background: rgb(247, 228, 194); */
  /* background: #defacf; */
  background: #f8efef;
  /* background: #e4f1ff; */
}
</style>